import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { combineLatest } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

import Card from 'react-bootstrap/Card';
import '../../../css/card.css';


import BootstrapTable from 'react-bootstrap-table-next';

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

import Dropdown, { MenuItem } from '@trendmicro/react-dropdown';


// Be sure to include styles at some point, probably during your bootstraping
import '@trendmicro/react-buttons/dist/react-buttons.css';
import '@trendmicro/react-dropdown/dist/react-dropdown.css';

import { userAssociatedFacilities } from '../../../common/services/ApiService';
import { definitionsByType } from '../../../common/services/ReportService';
import { getAdminRecallInformation, recallPrintTypes, updateRecallPrintTypes } from '../../../common/services/RecallService';

import { toast } from '@rickylandino/react-messages';
import { Select } from 'antd';

class ManageRecallDefinitions extends Component {
    constructor(props) {
        super(props);

        this.state = {
            definitionIcons: [],
            definitionsByType: {},
            recallPrintTypes: [],
            loaded: false,
            facilities: [],
            formFields: {
                facilityID: ''
            },
            showAddModal: false,
            newIconDefinition: {
                definitionName: 'Select a definition',
                facilityID: '',
                printIconName: ''
            }
        }

        this.alive = false;
    }

    componentDidMount() {
        this.alive = true;

        combineLatest(
            userAssociatedFacilities,
            definitionsByType
        ).pipe(takeWhile(() => this.alive)).subscribe(response => {
            if (response[1]) {
                let facilities = response[0];

                let defaultFacility = facilities.find(f => f.defaultFacility === 1)?.facilityModel?.facilityID || facilities[0].facilityModel.facilityID;

                getAdminRecallInformation(defaultFacility);
                
                let definitionsByType = { ...this.state.definitionsByType };

                Object.keys(response[1]).map(key => {
                    if (key.toLowerCase().includes("recall")) {
                        definitionsByType[key] = response[1][key];
                    }
                    
                });

                this.setState({
                    facilities,
                    formFields: { ...this.state.formFields, facilityID: defaultFacility },
                    definitionsByType,
                    allDefinitionsByType: response[1]
                });
            }
        });

        recallPrintTypes.pipe(takeWhile(() => this.alive)).subscribe(response => {
            if (response.length > 0) {
                this.setState({
                    loaded: false
                });

                let recallPrintTypes = [...this.state.recallPrintTypes];
                recallPrintTypes = [...response];

                this.setState({
                    recallPrintTypes,
                    loaded: true
                });
            }
        });
    }

    componentWillUnmount() {
        this.alive = false;
    }

    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({ formFields: { ...this.state.formFields, [name]: value } }, () => {
            getAdminRecallInformation(this.state.formFields.facilityID);
        });
    }

    handleDefinitionSelection = (eventKey, event) => {
        if (eventKey) {
            let splitStr = eventKey.split(", ");
            let keyName = splitStr[0];
            let guid = splitStr[1];
            let recallPrintTypesID = splitStr[2];

            let definitionSelected = this.state.definitionsByType[keyName].find(item => item.definitionMasterID === guid);

            let recallPrintTypes = [...this.state.recallPrintTypes];
            let itemToChange = recallPrintTypes.findIndex(rpt => rpt.recallPrintType.recallPrintTypesID === recallPrintTypesID);

            recallPrintTypes[itemToChange].recallPrintType.reportDefinitionMasterID = definitionSelected.definitionMasterID;
            recallPrintTypes[itemToChange].isDirty = true;
            this.setState({
                recallPrintTypes
            });
        }
    }

    handleFallbackDefinitionSelection = (eventKey, event) => {
        if (eventKey) {
            let splitStr = eventKey.split(", ");
            let keyName = splitStr[0];
            let guid = splitStr[1];
            let recallPrintTypesID = splitStr[2];

            let definitionSelected = this.state.definitionsByType[keyName].find(item => item.definitionMasterID === guid);

            let recallPrintTypes = [...this.state.recallPrintTypes];
            let itemToChange = recallPrintTypes.findIndex(rpt => rpt.recallPrintType.recallPrintTypesID === recallPrintTypesID);

            recallPrintTypes[itemToChange].recallPrintType.reportDefinitionFallbackID = definitionSelected.definitionMasterID;
            recallPrintTypes[itemToChange].isDirty = true;
            this.setState({
                recallPrintTypes
            });
        }
    }

    handleSubmit = () => {
        let listToUpdate = this.state.recallPrintTypes.filter(i => i.isDirty);

        let postdata = {
            recallPrintTypes: listToUpdate,
            facilityID: this.state.formFields.facilityID
        };

        updateRecallPrintTypes(postdata).then(data => {
            if (data) {
                toast.success("Recall Print Type has been updated");
            } else {
                toast.error("Something went wrong");
            }
        }).catch(error => {
            toast.error("Something went wrong");
        });
    }

    handleFacilityChange = (selectedFacilityID) => {
        this.setState({ formFields: { ...this.state.formFields, facilityID: selectedFacilityID } }, () => {
            getAdminRecallInformation(selectedFacilityID);
        });
    }

    render() {
        let th = this;

        function dropdownFormatter(cell, row, rowIndex, formatExtraData) {
            let definitionsByType = formatExtraData.defByType;
            var name = '';

            for (var i = 0; i < Object.keys(definitionsByType).length; i++) {
                let key = Object.keys(definitionsByType)[i];
                name = definitionsByType[key].find(d => d.definitionMasterID === cell)?.definitionName || '';
                if (name) break;
            }

            return (
                <div>
                    <Dropdown
                        onSelect={(eventKey, event) => {
                            th.handleDefinitionSelection(eventKey, event);
                        }}
                        className="mw-50 custom-nested-dropdown"
                    >
                        <Dropdown.Toggle title={name} className="w-100 mh-32" />
                        <Dropdown.Menu className="custom-dropdown-menu">
                            {Object.keys(definitionsByType).map(function (key) {

                                var filteredList = definitionsByType[key].filter(item => item.facilityID && item.facilityID === th.state.formFields.facilityID);

                                return (
                                    <MenuItem key={key} className="sub-menu-item">
                                        {key}
                                        {filteredList.length > 0 && filteredList.map((item, idx1) => {
                                            return idx1 === 0 &&
                                                <MenuItem header className="color-pink" key={idx1}>Facility Definitions</MenuItem>
                                        })}

                                        {filteredList.length > 0 && filteredList.map((item, idx) =>
                                            <MenuItem className="hoverable" key={idx} eventKey={key + ", " + item.definitionMasterID + ", " + row.recallPrintType.recallPrintTypesID}>{item.definitionName}</MenuItem>
                                        )}

                                        {definitionsByType[key].filter(item => !item.facilityID).map((item, idx1) => {
                                            return idx1 === 0 &&
                                                <MenuItem header className="color-pink" key={idx1}>Global Definitions</MenuItem>
                                        })}

                                        {definitionsByType[key].filter(item => !item.facilityID).map((item, idx) =>
                                            <MenuItem className="hoverable" key={idx} eventKey={key + ", " + item.definitionMasterID + ", " + row.recallPrintType.recallPrintTypesID}>{item.definitionName}</MenuItem>
                                        )}
                                    </MenuItem>
                                );
                            })}
                        </Dropdown.Menu>
                    </Dropdown>
                    {row.recallPrintType?.facilityID !== "00000000-0000-0000-0000-000000000000" && <span className="ml-3 fs-24 color-pink">*</span>}
                </div>
            );
        }

        function dropdownFallbackFormatter(cell, row, rowIndex, formatExtraData) {
            let definitionsByType = formatExtraData.defByType;
            var name = '';

            for (var i = 0; i < Object.keys(definitionsByType).length; i++) {
                let key = Object.keys(definitionsByType)[i];
                name = definitionsByType[key].find(d => d.definitionMasterID === cell)?.definitionName || '';
                if (name) break;
            }

            return (
                <div>
                    <Dropdown
                        onSelect={(eventKey, event) => {
                            th.handleFallbackDefinitionSelection(eventKey, event);
                        }}
                        className="mw-50 custom-nested-dropdown"
                    >
                        <Dropdown.Toggle title={name} className="w-100 mh-32" />
                        <Dropdown.Menu className="custom-dropdown-menu">
                            {Object.keys(definitionsByType).map(function (key) {

                                var filteredList = definitionsByType[key].filter(item => item.facilityID && item.facilityID === th.state.formFields.facilityID);

                                return (
                                    <MenuItem key={key} className="sub-menu-item">
                                        {key}
                                        {filteredList.length > 0 && filteredList.map((item, idx1) => {
                                            return idx1 === 0 &&
                                                <MenuItem header className="color-pink" key={idx1}>Facility Definitions</MenuItem>
                                        })}

                                        {filteredList.length > 0 && filteredList.map((item, idx) =>
                                            <MenuItem className="hoverable" key={idx} eventKey={key + ", " + item.definitionMasterID + ", " + row.recallPrintType.recallPrintTypesID}>{item.definitionName}</MenuItem>
                                        )}

                                        {definitionsByType[key].filter(item => !item.facilityID).map((item, idx1) => {
                                            return idx1 === 0 &&
                                                <MenuItem header className="color-pink" key={idx1}>Global Definitions</MenuItem>
                                        })}

                                        {definitionsByType[key].filter(item => !item.facilityID).map((item, idx) =>
                                            <MenuItem className="hoverable" key={idx} eventKey={key + ", " + item.definitionMasterID + ", " + row.recallPrintType.recallPrintTypesID}>{item.definitionName}</MenuItem>
                                        )}
                                    </MenuItem>
                                );
                            })}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            );
        }

        function checkboxFormatter(cell, row, rowIndex) {
            return (
                <div className="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" className="custom-control-input" id="notApplicable" name="showUpcoming" defaultChecked={cell || false} />
                    <label className="custom-control-label"></label>
                </div>
            );
        }

        const columns = [{
            dataField: 'recallPrintType.recallPrintType',
            text: 'Recall Print Type'
        },{
            dataField: 'recallPrintType.reportDefinitionMasterID',
            text: 'Selected Definition',
            formatter: dropdownFormatter,
            formatExtraData: {
                defByType: this.state.definitionsByType
            },
            },{
            dataField: 'recallPrintType.reportDefinitionFallbackID',
            text: 'Fallback Definition',
            formatter: dropdownFallbackFormatter,
            formatExtraData: {
                defByType: this.state.definitionsByType
            },
            }, {
                dataField: 'recallPrintType.notApplicable',
                text: 'Not Applicable',
                formatter: checkboxFormatter,
                headerStyle: () => {
                    return { width: '200px' };
                }
            }];

        const selectRow = {
            mode: 'radio',
            clickToSelect: true,
            hideSelectColumn: true
        };

        const rowEvents = {
            onClick: (e, row, rowIndex) => {
                if (e.target.id === 'notApplicable') {
                    let recallPrintTypes = [...this.state.recallPrintTypes];

                    recallPrintTypes[rowIndex].recallPrintType.notApplicable = e.target.checked;
                    recallPrintTypes[rowIndex].isDirty = true;
                    this.setState({
                        recallPrintTypes
                    });

                }
            }
        };

        let defByType = this.state.definitionsByType;

        let { Option } = Select;

        return (
            <Fragment>
                {this.state.loaded &&
                    <Fragment>
                        <div className="row justify-content-between">
                            <div className="form-group col-lg-3 col-12">
                                <label className="form-label">Selected Facility</label>
                            <Select
                                allowClear
                                placeholder="Please select"
                                onChange={this.handleFacilityChange}
                                className="form-control-custom w-100"
                                bordered={false}
                                value={this.state.formFields.facilityID || ''}
                                showSearch
                                filterOption={(input, option) => (option.children[0] + option.children[1]).toLowerCase().includes(input.toLowerCase())}
                            >
                                {this.state.facilities.map((fac, idx) => <Option key={idx} key={fac.facilityModel.facilityID} value={fac.facilityModel.facilityID}>{fac.facilityModel.facilityNumber && fac.facilityModel.facilityNumber + " - "}{fac.facilityModel.facilityName}</Option>)}
                            </Select>
                        </div>
                        <div className="form-group col-lg-3 col-12">
                             <fieldset><span className="ml-3 fs-24 color-pink">*</span> = Facility Specific Recall Print Type</fieldset>
                        </div>
                        </div>
                        <Card className="pinkCard">
                            <Card.Header><span>Print Recall Definitions</span>
                            </Card.Header>
                            <Card.Body>
                                <div className="fullTable">

                                    <BootstrapTable keyField='recallPrintType.recallPrintTypesID'
                                        data={this.state.recallPrintTypes}
                                        columns={columns}
                                        selectRow={selectRow}
                                        rowEvents={rowEvents}
                                        condensed />

                                </div>
                            </Card.Body>

                        </Card>
                        <button className="btn btn-submit" onClick={this.handleSubmit}>Save</button>
                    </Fragment>
                }
            </Fragment>
        );
    }
}

export default withRouter(ManageRecallDefinitions);